import React, {useMemo, useState} from 'react';
import PropTypes from 'prop-types';
import {FmlxPopover, FmlxList, FmlxDivider} from 'fmlx-common-ui';
import MenuIcon from 'components/MenuIcon/MenuIcon';

function ProtocolExplorerDropDown({menuList, menuLabel, menuIcon, dropDownIcon, onClick, hidden}) {
  const [anchorEl, setAnchorEl] = useState(null);

  const handleClick = (e) => {
    if (onClick) {
      onClick();
      return;
    }
    setAnchorEl(e.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const currentMenuList = useMemo(
    () =>
      menuList.map((menu) => {
        if (menu.onClick && typeof menu.onClick === 'function') {
          return {
            ...menu,
            onClick: () => {
              setAnchorEl(null); // close popover first
              menu.onClick();
            },
          };
        }
        return menu;
      }),
    [menuList],
  );

  return hidden ? (
    // eslint-disable-next-line react/jsx-no-useless-fragment
    <></>
  ) : (
    <>
      <MenuIcon icon={menuIcon} label={menuLabel} onClick={handleClick} dropDownIcon={dropDownIcon} />

      <FmlxPopover open={Boolean(anchorEl)} anchorEl={anchorEl} onClose={handleClose}>
        {currentMenuList.map((item) =>
          // eslint-disable-next-line
          item.divider ? (
            <FmlxDivider />
          ) : item.htmlFor ? (
            // eslint-disable-next-line
            <label htmlFor={item.htmlFor}>
              {/* eslint-disable-next-line react/jsx-props-no-spreading */}
              <FmlxList {...item} />
            </label>
          ) : (
            // eslint-disable-next-line react/jsx-props-no-spreading
            <FmlxList {...item} />
          ),
        )}
      </FmlxPopover>
    </>
  );
}

ProtocolExplorerDropDown.propTypes = {
  menuList: PropTypes.arrayOf(PropTypes.object),
  menuIcon: PropTypes.string,
  menuLabel: PropTypes.string,
  dropDownIcon: PropTypes.bool,
  onClick: PropTypes.func,
  hidden: PropTypes.bool,
};
ProtocolExplorerDropDown.defaultProps = {
  menuList: [],
  menuLabel: '',
  menuIcon: '',
  dropDownIcon: true,
  onClick: null,
  hidden: false,
};

export default ProtocolExplorerDropDown;
